import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import ChampionshipSmallCard from '@/components/Cards/ChampionshipSmallCard'
import { winIcon } from '@/images'
import { IChampionship } from '@/interfaces/Championship'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React from 'react'
import style from './styles/cabinet_championship.module.scss'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import { api } from '@/api'
import { Filters } from './components/Filters'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import Button from '@/components/Button'
import { useConfig } from '@/hooks'

// TODO Проверить value в селекте при привязке бэка
const CabinetChampionships = (): React.ReactElement => {
  const config = useConfig()

  return (
    <FetcherList initFilter={{ page_size: 5, status: '' }} isScrollTop={false} isHistoryPush={false} api={api.getUserChampionships}>
      {({ results, status, loadData, filterParams }: IFetcherListResults<IChampionship[]>) => {
        return (
          <>
            <Filters handleFilter={loadData} initFilters={filterParams} />
            {status === dataStates.loading ? <BlockSpinner /> : null}
            {status === dataStates.loaded && results.length === 0
              ? (
                <div className={style.empty}>
                  <GxIcon src={winIcon} className={style.empty__icon} />
                  <span className={style.empty__text}>
                    Ты еще не участвовал в&nbsp;чемпионатах
                  </span>
                  <Button wide highlight href={config.championships} className={style.empty__button}>
                    Принять участие
                  </Button>
                </div>
                )
              : null}
            {status === dataStates.loaded && results.length > 0
              ? (
                  results.map((el) => {
                    return (
                      <ChampionshipSmallCard
                        key={el.id}
                        championship={el}
                        isCabinetCard
                      />
                    )
                  })
                )
              : null}

          </>
        )
      }}
    </FetcherList>
  )
}

export default CabinetChampionships
